import { render } from "./AuditLogsView.vue?vue&type=template&id=7653dd40"
import script from "./AuditLogsView.vue?vue&type=script&lang=js"
export * from "./AuditLogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__